<template>
<div>
    <b-row v-if="audit">
        <b-col>
            <h2>Audit - id:{{ audit.audit_id }}</h2>
        </b-col>
    </b-row>
    <b-row v-if="audit">
        <b-col cols=3>
            Order number: {{ audit.order_no }}<br />
            Date: {{ audit.date }}<br />
            Reason: {{ audit.reason }}<br />
            Supplier Number: {{ audit.supplier_number }}<br />
            Used catalogue: <b>VDA 6.3</b>
        </b-col>
    </b-row>
    <b-row>
        <b-col>
            <b-card v-for="group in rating_groups" :title="group.questionnaire_group.name + ' ' + group.questionnaire_group.description">
            <b-card v-if="group.questionnaire_group.child_questionnaire_groups" v-for="child_group in group.questionnaire_group.child_questionnaire_groups" :title="child_group.questionnaire_group.name + ' ' + child_group.questionnaire_group.description">
                <table class="table">
                    <tr>
                        <th width=10%>No</th>
                        <th>Questionnaire</th>
                        <th width=6%>Rating</th>
                    </tr>
                    <tr v-for="rating in child_group.ratings">
                        <td>{{ rating.questionnaire.name }}</td>
                        <td>{{ rating.questionnaire.description }}</td>
                        <th>{{ rating.rating_product }}<span v-if="rating.questionnaire.double_rating"> | {{ rating.rating_process }}</span></th>
                    </tr>
                </table>
            </b-card>

            <table v-if="group.ratings.length > 0" class="table">
                <tr>
                    <th width=10%>No</th>
                    <th>Questionnaire</th>
                    <th width=6%>Rating</th>
                </tr>
                <tr v-for="rating in group.ratings" @click="on_click(rating)">
                    <td>{{ rating.questionnaire.name }}</td>
                    <td>{{ rating.questionnaire.description }}</td>
                    <th>{{ rating.rating_product }}<span v-if="rating.questionnaire.double_rating"> | {{ rating.rating_process }}</span></th>
                </tr>
            </table>
        </b-card>
        </b-col>
    </b-row>
</div>
</template>

<script>
import axios from 'axios';
import QuestionnaireRating from '@/components/QuestionnaireRating.vue'

export default {
  data () {
    return {
        form: {
            'step_number': '',
            'description': '',
            rating_product: 0,
            rating_process: 0,
            notes: '',
        },
        audit: null,
        rating_groups: null,
        currentrating: null,
        name: '',
        description: '',
        file: null,
    }
  },
  created () {
      this.fetchData()
  },
  watch: {
      '$route': 'fetchData'
  },
  methods: {
      on_click(currentrating) {
          this.currentrating = currentrating;
          this.form.rating_product = currentrating.rating_product;
          this.form.rating_process = currentrating.rating_process;
          this.form.notes = currentrating.notes;
          this.name = currentrating.questionnaire.name;
          this.description = currentrating.questionnaire.description;
          this.$refs.refModal2.show();
      },
      fetchData() {
          this.error = this.post = null;
          this.loading = true;
          this.$http.get('v1/audits/' + this.$route.params.audit_id + '/perform').then(response => {
              this.audit = response.data.response.audit;
              this.rating_groups = response.data.response.rating_groups;
              this.loading = false;
          });
      },
      ok_handler() {
          this.$http.put('v1/ratings/' + this.currentrating.rating_id, {
              rating_product: this.form.rating_product,
              rating_process: this.form.rating_process,
              notes: this.form.notes
          }).then(response => {
              this.fetchData();
          });
      }
  },
  components: {
      QuestionnaireRating
  }
}
</script>
<style>
.process_step_card {
    margin-bottom: 10px;
}
.col-maxwidth {
    max-width: 300px;
}
</style>